export default __webpack_public_path__ + "static/media/Catacomb Gauntlets.16c7efae.jpg";